/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `` - NONE
 * * `🏻` - LIGHT
 * * `🏼` - MEDIUM_LIGHT
 * * `🏽` - MEDIUM
 * * `🏾` - MEDIUM_DARK
 * * `🏿` - DARK
 */
export enum EmojiSkinTone {
  NONE = '',
  LIGHT = '🏻',
  MEDIUM_LIGHT = '🏼',
  MEDIUM = '🏽',
  MEDIUM_DARK = '🏾',
  DARK = '🏿',
}
